import React, { Fragment } from 'react';
import { Icon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { contactOptionIcons } from '../../common/constants';

function ContactOptionIcon({ type, size, className, ...rest }) {
  const renderContactOptionIcon = () => {
    switch (type) {
      case contactOptionIcons.COMMUNITY:
        return <Icon name="community" size={size} className={className} {...rest} />;
      case contactOptionIcons.CALLUS:
      case contactOptionIcons.PHONE:
        return <Icon name="phone-2" size={size} className={className} {...rest} />;
      case contactOptionIcons.MESSAGE:
      case contactOptionIcons.CHAT:
      case contactOptionIcons.MESSAGE_US:
        return <Icon name="chat" size={size} className={className} {...rest} />;
      case contactOptionIcons.RES_CENTER:
      case contactOptionIcons.SELLER:
        return <Icon name="resolution" size={size} className={className} {...rest} />;
      case contactOptionIcons.ARTICLE:
        return <Icon name="books" size={size} className={className} {...rest} />;
      default:
        return null;
    }
  };

  return <Fragment>{renderContactOptionIcon()}</Fragment>;
}

ContactOptionIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default ContactOptionIcon;
